<template>
    <div class="page">
        <mu-toast v-if="toast" v-bind:message="hintMsg" @close="hideToast" id="alertline" />
        <mu-refresh-control :refreshing="refreshing" :trigger="trigger" @refresh="refresh"/>
        <pageTitle title="我的免房券" :showRight='true' rightTitle='使用规则' @rightHandler='open'/>
        <div class='convert'>
          <input type='text' v-model='couponCode' placeHolder='请输入您的免房券编号'/>
          <a v-on:click='exchangeFreeVo'>兑换</a>
        </div>
        <div class="demo-refresh-container">
          <div class='vouchers'>
              <div class="vocherbg" v-on:click='choose(index)' v-for='(vo,index) in freeVochers'>
                <div class="left">
                  <div class="vochermain valid">
                    ￥<span class="num">{{vo.Amount}}</span>
                  </div>    
                </div>
                <div class="right">
                  <div class='fCon'>
                    <h4>免房券</h4>
                    <span class='date'>有效期至&nbsp;&nbsp;{{vo.ExpireDate}}</span>
                  </div>
                  <div v-if='vo.Status == "0" && g_currentOrder.freeVoucherInfo.useNotSee' v-bind:class="{ 'active': vo.selected }" class='fBtn'></div>
                </div>
              </div>       
          </div>
        </div>
        <loadListTail mainTitle='邀请好友注册有机会抽免房券哦！' mainIcon='noVoucher' :extendBtn='false' btnText='去邀请好友' @btnHandler='goInvite' :noMore='loadState.stop' :isLoading='loadState.loading' :overZero='freeVochers.length > 0'  />
        <div>
        </div>
        <div style="text-align:center;padding:0.2rem;" v-if='loadState.loading'>
          <img src="../../../static/LoadingBest.gif" style=" width:1.2rem ;" />
        </div>
        <mu-dialog :open="dialog" @close="close">
          <div style="margin:-27px;border-radius:8px;">
            <div style='width:100%;background-color:#27ba60;height:1.2rem;line-height:1.2rem;text-align:center;color:#ffffff;font-size:0.36rem;font-weight:600;'>
              使用规则
            </div>
            <div style='padding:1em 2em 3em 2em;color:#666666;font-size:0.28rem;line-height:0.34rem;'>
              <p>1.免房券适用于所有格美系酒店（格林东方、格美、格雅、格菲、格林豪泰、格林联盟、青皮树、贝壳），不适用于促销类房型；</p>
              <p>2.使用免房券可当天预订，每个订单仅限一间一晚；</p>
              <p>3.免房券面额有200元、300元，可累计使用，如门市价350元，可使用2张200元免房券进行预订，余额不找零不兑现；</p>
              <p>4.预订方式同普通订房的操作步骤，只需在提交订单时勾选“使用免房券抵扣”，并填写实际入住人的姓名；</p>
              <p>5.免房券设有有效期，请在此之前完成预订及入住，具体有效期限请至“会员中心—我的免房券”查询，过期无效；</p>
              <p>6.免房券订单最晚取消时间为入住日18点，超时取消或未入住均无法退还免房券；</p>
              <p>7.免房券订单退房时间为中午12点，不赠送早餐，不累计K币，不与其他优惠同享。</p>
            </div>
          </div>
        </mu-dialog>
    </div>
</template>



<style lang="less" scoped>
    @import "../../assets/theme.less";
    .demo-infinite-container{
      -webkit-overflow-scrolling: touch;
    }
    .mu-dialog{
        margin-bottom:-48px;
    }
    .mu-toast{
        text-align:center;
        width:70%;
        margin:15%;
    }
    .page{
        background-color:#f2f2f2;
      .topRule{
        position:absolute;
        top:0;
        right:1em;
        font-size:0.3rem;
        color:#ffffff;
      }
      .convert{
          background-color:#ffffff;
          height:1.2rem;
          display:flex;
          input{
            background-color:#f2f2f2;
            border-radius:6px;
            font-size:0.3rem;
            width:5.6rem;
            height:0.7rem;
            line-height:0.7rem;
            outline:none;
            border:none;
            margin:auto 1em;
            padding-left:1em;
          }
          a{
              width:1.1rem;
              text-align:center;
              margin:auto 0;
              background-color:#27ba60;
              color:#ffffff;
              font-size:0.3rem;
              border-radius:6px;
              height:0.7rem;
              line-height:0.7rem;
          }
      }
      .vocherbg{
        width:6.91rem;
        text-align:center;
          .left{
            background-color:white;
            float:left;
            display:flex;
            display: -webkit-flex;
            height:100%;
            border-radius:3px;
            vertical-align:center;
            border-right:1px dashed #F1F1F1;
            padding:0.5em;
            .valid{
              width:2.26rem;
              background:url(../../../static/wallet/vocher/valid.png) no-repeat;
            }
            .invalid{
              background:url(../../../static/wallet/vocher/invalid.png) no-repeat;
            }
            .vochermain{
              background-size:100% 100%;
              font-size:0.28rem;
              width:2.26rem;
              height:1.6rem;
              color:white;
              .num{
                font-size:0.54rem;
              }
              text-align:center;
              margin:auto;
              padding-right:0.2rem;
              line-height:1.6rem;
            }
           }
            .used{
                background:url(../../../static/wallet/vocher/used.png) no-repeat right;
            }
            .outdate{
                background:url(../../../static/wallet/vocher/outdate.png) no-repeat right;
            }
            .right{
                display:flex;
                width:4.2rem;
                background-color:white;
                height:100%;
                  .fCon{
                    text-align:left;
                    font-size:0.24rem;
                    color:@textColor;
                    float:left;
                    border-radius:8px 3px 3px 8px;
                    padding:0.51rem 0 1em 1.5em;
                    h4{
                      margin:0 0 0.5em 0;
                      color:@primaryBlack;
                      font-size:0.3rem;
                      font-weight:500;
                    }
                    .date{
                      display:block;
                      width:2.9rem;
                    }
                  }

                .fBtn{
                  display:block;
                  height:20px;
                  width:20px;
                  margin:auto;
                  background:url(../../../static/wallet/vocher/freeVoFalse.png) no-repeat;
                  background-size:100%100%; 
                }
                .active{
                    background:url(../../../static/wallet/vocher/freeVotrue.png) no-repeat;
                    background-size:100%100%; 
                }
            }
            margin:auto;
            margin-top:0.2rem;
            height:2.04rem;
          }
    }
</style>



<script>
import api from '../../api'
import { mapGetters } from 'vuex'
import { mapMutations } from 'vuex'
import loadListTail from '../../components/loadListTail'
import Scroll from '../../utils/loading'
export default {
  data () {
    return {
      dialog: false,
      toast: false,
      freeVochers:[],
      loadState:'',
      hintMsg:'',
      pageSize:10,
      refreshing: false,
      trigger: null,
      couponCode:'',
      scroll:null
    }
  },
  activated(){
    this.scroll.addHandler()
    if(!this.g_currentOrder.freeVoucherInfo.useNotSee && !this.loadState.loaded){
      this.initData()
    }
  },
  mounted(){
    this.trigger = this.$el
    this.scroll = Scroll.Create(this,this.getData,this.pageSize,1)
  },
  deactivated(){
    this.getSelected()
    this.scroll.removeHandler()
  },
  components: {
    loadListTail
  },
  methods: {
    ...mapMutations(['setG_currentOrder'
    ]),
    initData(){
      //清空显示数据
      this.freeVochers = []
      //初始化本页控制数据、分页参数
      this.scroll.refresh()
    },
    refresh () {
      this.refreshing = true
      setTimeout(() => {
        this.refreshing = false
        this.initData()
      }, 2000)
    },
    //获取免房券
    getData () {
      var that = this
      var params = new this.URLSearchParam();
      params.append('page', this.pageParam.index);
      params.append('pageSize', this.pageSize);
      // params.append('checkInDate', this.g_currentOrder.freeVoucherInfo.useNotSee?this.g_currentOrder.startDate:"");
      // params.append('roomPrice', this.g_currentOrder.freeVoucherInfo.useNotSee?this.g_currentOrder.amount:"");
      return new Promise(function(resolve, reject) {
        that.$http.post(api.getFreeVouchers(),params.toParam()).then((res) => {
          if(res.Result){
              var temp = res.Data

              that.initFreeVOuchers(temp)
              that.freeVochers = that.freeVochers.concat(temp)
              resolve(temp.length)
          }
          else{
            resolve(null)
            that.hintMsg = res.Message
            that.showToast()
          }
        })
      })

    },
    initFreeVOuchers(data){
      //初始化免房券
      data.forEach((item,index,array) => {
        item.selected = false
      })
    },
    //点击事件
    choose(index){
      var vo = this.freeVochers[index]
      //如果是可用的抵房券
      if(vo.Status == "0" && this.g_currentOrder.freeVoucherInfo.useNotSee){
        if(!vo.selected && this.freeAmount >= this.g_currentOrder.amount){
          this.hintMsg = '您选择的免房券已足够抵扣，请勿再选！'
          this.showToast()
          return
        }
        vo.selected = !vo.selected
      }
    },
    post(){
      var params = new this.URLSearchParam();
      if(this.code == null || this.code == ''){
        this.hintMsg = "兑换码不能为空";
        this.showToast()
        return
      }
      else{
        params.append('couponCode', this.code);
        this.$http.post(api.exchangeCouponByCouponCode(),params.toParam()).then((res) => {
            if(res.Result){
                var temp = res.Data;
                //刷新数据
                this.initData()
                this.hintMsg = '兑换成功'
                this.showToast ();
            }
            else{
                this.hintMsg = res.Message;
                this.showToast ();
            }
        })
      }

    },
    open () {
      this.dialog = true
    },
    close () {
      this.dialog = false
    },
    // 弹出层
    showToast() {
      this.toast = true;
      if (this.toastTimer) clearTimeout(this.toastTimer);
      this.toastTimer = setTimeout(() => {
        this.toast = false;
      }, 1000);
      if (this.hintMsg == "未登录") {
        this.$http.post(api.LogOff()).then(res => {});
        this.$store.dispatch("clearUser");
        this.toastTimer = setTimeout(() => {
          this.$router.push({ path: "/user/login" });
        }, 1200);
      }
    },
    hideToast () {
      this.toast = false
      if (this.toastTimer) clearTimeout(this.toastTimer)
    },
    goback(){
      this.$router.go(-1)
    },
    //获取选中值
    getSelected(){
      var currentOrder = this.g_currentOrder
      var tempStr = ''
      var tempAmount = 0
      this.freeVochers.forEach((item, index , array) => {
        if(item.selected){
          tempAmount += Number(item.Amount)
          tempStr += item.Id
          tempStr += ','
        }
      })
      currentOrder.freeVoucherInfo.selected = tempStr
      currentOrder.freeVoucherInfo.amount = tempAmount
      this.setG_currentOrder(currentOrder)
    },
    //兑换免房券
    exchangeFreeVo(){
      if(this.couponCode == ''){
        this.hintMsg = '请输入免房券编号！'
        this.showToast()
        return
      }
      this.hintMsg = '兑换中，请稍后'
      this.showToast()
      var params = new this.URLSearchParam();
      params.append('couponCode', this.couponCode);
      this.$http.post(api.exchangeFreeRoomCoupon(),params.toParam()).then((res) => {
        
        if(res.Result){
          this.hintMsg = res.Data
          this.initData()
        }
        else{
          this.hintMsg = res.Message
        }
        this.showToast()
      })
    },
    goInvite(){
      this.$router.push({ path: '/activity/InvitationRegister?sign=wWY18ovKCRW1iIlh2oFZRg%3D%3D%0A' });
    }
  },
  computed:{
    ...mapGetters(['g_currentOrder','g_searchParam ']),
    freeAmount(){
      var tempAmount = 0
      this.freeVochers.forEach((item, index , array) => {
        if(item.selected){
          tempAmount += Number(item.Amount)
        }
      })
      return tempAmount
    }
  },
}
</script>


// WEBPACK FOOTER //
// freeVouchers.vue?f7216a0e